import React, { useState } from "react";
import Modal_started from "../Home/Modal_started";
import useDocumentTitle from "../../useDocumentTitle";

const LogoMarquee = ({
    speed = 48,     // mayor = más sutil/lento
    gapRem = 3,     // separación entre logos (rem)
  }) => {
    // Ajustes finos por marca (por si alguna es demasiado ancha/alta visualmente)
    // Puedes quitar/ajustar estas entradas si no las necesitas.
    const brandAdjust = {
      "Sushiexpress1.webp": "scale-90",
      "Elcosto.webp": "scale-90",
      "Grupotova.webp": "scale-90",
    };
  
    const logos = [
      // === 9 nuevos primero ===
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Yogen_Fruz_Logo.svg_rbdk1o.png", alt: "Yogen Fruz" },
      { src: "https://img.invupos.com/clauweb/Empresas/Olive-garden.png", alt: "Olive Garden" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Krispy_Kreme_logo.svg_sshr2p.png", alt: "Krispy Kreme" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Subway.logo.8.5_e0sw4o%20%283%29.svg", alt: "Subway" },
      { src: "https://img.invupos.com/webinvu/Delivery/SOCIALTEL-LOGO-02.png", alt: "Selina" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/cropped-Website-Ajisen-37_vdskkr.webp", alt: "Ajisem Ramen" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/IHOP_logo.svg_nwncuz.png", alt: "Ihop" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Cinnabon_logo.svg_unlk2s.png", alt: "Cinnabon" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Little-Caesars-Logo_elzm7x.png", alt: "Little Caesars" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Logo-maito-negro_vl6w8p.png", alt: "Maito" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/cantina-del-tigre_nb9rjo.png", alt: "Cantina del tigre" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/UNIDO_LOGO_01_1_riim8k.png", alt: "Unido" },
    ];
  
    // Duplicamos dentro de UNA sola pista para loop perfecto sin “salto”
    const track = [...logos, ...logos];
  
    return (
      <div
        className="relative w-full overflow-hidden py-10 group"
        // máscara sutil para entradas/salidas suaves
        style={{
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
          maskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
        }}
      >
        <style>{`
          @keyframes marqueeX {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .marquee-track {
            display: flex;
            align-items: center;
            width: max-content;
            animation: marqueeX var(--marquee-duration, 48s) linear infinite;
            will-change: transform;
          }
          .marquee-track > * + * { margin-left: ${gapRem}rem; } /* separación entre “cajas” */
          .paused { animation-play-state: paused; }
  
          /* Respeta reduce motion */
          @media (prefers-reduced-motion: reduce) {
            .marquee-track { animation: none !important; transform: none !important; }
          }
  
          /* Ajuste leve por viewport para elegancia */
          @media (min-width: 1024px) {
            .marquee-root { --marquee-duration: ${speed + 6}s; }
          }
          @media (max-width: 480px) {
            .marquee-root { --marquee-duration: ${Math.max(30, speed - 6)}s; }
          }
        `}</style>
  
        <div className="marquee-root">
          <div className={`marquee-track group-hover:paused`}>
            {track.map((logo, i) => {
              // detectar nombre de archivo para ajuste fino opcional
              const filename = logo.src.split("/").pop() || "";
              const tweak = Object.keys(brandAdjust).find(key =>
                filename.includes(key)
              );
              const scaleClass = tweak ? brandAdjust[tweak] : "";
  
              return (
                <div
                  key={i}
                  className="flex-shrink-0 flex items-center justify-center 
                             h-[68px] sm:h-[76px] lg:h-[86px]
                             w-[clamp(140px,12vw,240px)]" // caja uniforme
                >
                  <img
                    src={logo.src}
                    alt={logo.alt || ""}
                    loading="lazy"
                    className={`max-h-full max-w-full object-contain ${scaleClass}`}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };


export default function Pagosflexibles({ images = {} }) {
  const {
    hero = "https://img.invupos.com/webinvu/Pagos%20flexibles/hero_kgntqv.png",
    cashier = "https://img.invupos.com/webinvu/Pagos%20flexibles/INVU_POS_El_Salvador-10_1_zraj6y.png",
    devices = "https://img.invupos.com/webinvu/Pagos%20flexibles/INVU_POS_El_Salvador-11_1_zyngtu.png",
    kiosk = "https://img.invupos.com/webinvu/Pagos%20flexibles/INVU_POS_El_Salvador-12_1_q7efy7.png",
  } = images;

  const [isOpen, setIsOpen] = useState(false);
  useDocumentTitle("PAGOS FLEXIBLES | INVU POS");

  return (
    <>
    {isOpen && <Modal_started setIsOpen={setIsOpen} />}
    <main className="text-gray-900">
      {/* HERO */}
      <section className="px-4 sm:px-6 lg:px-8 py-12 lg:py-20 max-w-7xl mx-auto grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight">
            Haz despegar tu negocio
            con pagos <span className="text-blue-600">flexibles</span>
          </h1>
          <p className="mt-6 text-lg text-gray-700 max-w-xl">
            Obtén todos los equipos e implementación de Invu POS con un plan de pago que se ajusta a tu ritmo.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <button
              onClick={() => {
              setIsOpen(true);
            }} className="px-6 py-3 rounded-full bg-blue-600 text-white font-semibold text-lg">Solicitar financiamiento
            </button>
            <button
              onClick={() => {
              setIsOpen(true);
            }} className="px-6 py-3 rounded-full bg-gray-100 text-gray-900 font-semibold border text-lg">Prueba el demo</button>
          </div>
        </div>
        <div className="w-full max-w-lg mx-auto">
          <img src={hero} alt="Hero" className="w-full object-cover rounded-2xl" />
        </div>
      </section>

      {/* ACCEDE A LA TECNOLOGÍA */}
      <section className="bg-gray-50 border-y">
        <div className="px-4 sm:px-6 lg:px-8 py-12 lg:py-20 max-w-7xl mx-auto">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold">Accede a la mejor tecnología a un buen costo</h2>
          <div className="mt-10 grid lg:grid-cols-2 gap-10 items-start">
            <div>
              <img src={cashier} alt="Cajero usando POS" className="w-full h-[460px] object-cover rounded-2xl" />
            </div>
            <ul className="space-y-8">
              <li className="flex items-start gap-3">
                <span className="text-green-600 text-xl sm:text-2xl">✅</span>
                <div>
                  <p className="font-bold text-lg sm:text-xl">
                    Financia hardware y equipos POS sin trámites complicados:
                  </p>
                  <p className="text-base sm:text-lg text-gray-700">
                    Obtén todo lo que necesitas para tu negocio sin papeleo extenso ni procesos largos.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-green-600 text-xl sm:text-2xl">✅</span>
                <div>
                  <p className="font-bold text-lg sm:text-xl">
                    Paga en cómodas cuotas, sin presionar tu flujo de caja:
                  </p>
                  <p className="text-base sm:text-lg text-gray-700">
                    Disfruta de la tecnología hoy y págala poco a poco, mientras tu negocio sigue creciendo.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-green-600 text-xl sm:text-2xl">✅</span>
                <div>
                  <p className="font-bold text-lg sm:text-xl">
                    Incluye implementación y soporte especializado:
                  </p>
                  <p className="text-base sm:text-lg text-gray-700">
                    No solo recibes el hardware: también cuentas con un equipo experto que te guía en todo momento.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-green-600 text-xl sm:text-2xl">✅</span>
                <div>
                  <p className="font-bold text-lg sm:text-xl">
                    Obtén lo mejor de Invu POS desde el día uno:
                  </p>
                  <p className="text-base sm:text-lg text-gray-700">
                    Comienza a usar tu POS completo sin esperar a tener el presupuesto completo.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section>
        <div className="px-4 py-12 mt-4 mx-auto max-w-screen-xl">
          <LogoMarquee speed={42} gapRem={2} />
        </div>
      </section>

      {/* ARRANCA TU NEGOCIO */}
      <section
  id="financiamiento"
  className="px-4 sm:px-6 lg:px-8 py-20 lg:py-28 max-w-7xl mx-auto"
>
  {/* Título */}
  <h2 className="text-center text-4xl sm:text-6xl lg:text-[72px] font-extrabold leading-[1.1] tracking-tight">
    Arranca tu negocio con <span className="text-blue-600">Invu POS</span>
    <span className="block text-black">y págalo mientras tu negocio avanza</span>
  </h2>

  <div className="mt-16 grid lg:grid-cols-[1.05fr_1fr] items-start gap-16 lg:gap-24">
    {/* Columna izquierda */}
    <div className="max-w-2xl space-y-10 mt-4">
      <p className="text-lg sm:text-xl text-gray-700 leading-relaxed">
        Con Pagos Flexibles de <span className="font-semibold">Invu POS</span> puedes financiar
        todo lo que necesitas: hardware, instalación, capacitación, con un plan que se ajusta a tus ventas.
      </p>

      {/* Ejemplo práctico */}
      <div className="rounded-2xl bg-white border p-8 sm:p-10 shadow-sm space-y-6">
        <p className="font-semibold text-xl">Ejemplo práctico:</p>
        <ul className="space-y-3 text-gray-900 text-base sm:text-lg list-disc pl-6">
          <li>
            <span className="font-semibold">Inversión total en hardware:</span> $2000
          </li>
          <li>
            <span className="font-semibold">Anticipo inicial debe ser el 50% del costo total :</span> $1,000
          </li>
          <li>
            <span className="font-semibold">Pagos</span> diarios, semanales o mensuales, según lo prefieras.
          </li>
        </ul>

        <p className="text-sm text-gray-500 leading-relaxed">
          *Los costos y planes de pago se determinan según la cantidad de equipos y el nivel de
          implementación requerido. El financiamiento inicia únicamente una vez que el contrato
          haya sido firmado por ambas partes y exista acuerdo mutuo sobre las condiciones establecidas.
        </p>

        <button
          type="button"
          className="inline-flex px-7 py-3 rounded-full bg-blue-600 text-white text-base font-medium shadow-md hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300"
        >
          Términos y condiciones
        </button>
      </div>
    </div>

    {/* Columna derecha */}
    <div className="relative w-full max-w-[48rem] mx-auto mt-5">
      <div className="absolute -top-12 -right-10 w-[600px] h-[600px] bg-blue-100 rounded-full -z-10" />
      <img
        src={devices}
        alt="Invu POS dispositivos"
        className="w-full h-auto object-contain"
      />
    </div>
  </div>
</section>

      {/* RENOVAR TU RESTAURANTE */}
      <section id="demo" className="bg-gray-50 border-t">
  <div className="px-4 sm:px-6 lg:px-8 py-16 lg:py-24 max-w-7xl mx-auto">
    {/* Título full-width como en la referencia */}
    <h2 className="text-4xl sm:text-6xl lg:text-[68px] font-extrabold leading-[1.05] tracking-tight">
      Renovar tu restaurante está al{" "}
      <span className="text-blue-600">alcance</span>
      <br className="hidden sm:block" />
      <span className="text-blue-600">de tu bolsillo</span>
    </h2>

    {/* Dos columnas: imagen izquierda, texto derecha */}
    <div className="mt-10 grid lg:grid-cols-2 items-start gap-12 lg:gap-24">
      {/* Imagen */}
      <div className="max-w-[42rem] w-full">
        <img
          src={kiosk}
          alt="Kiosko"
          className="w-full h-auto object-contain drop-shadow-2xl"
        />
      </div>

      {/* Texto + bullets + botones */}
      <div className="max-w-2xl">
        <p className="text-lg sm:text-xl text-gray-700">
          Con el financiamiento de <span className="font-semibold">Invu POS</span> es más
          fácil estrenar o renovar equipos. Actualiza tu negocio con pagos flexibles y sin
          preocuparte por grandes inversiones.
        </p>

        <ul className="mt-6 space-y-4 text-lg sm:text-xl leading-relaxed text-gray-900">
          <li>✅ Renueva tus equipos sin descapitalizarte</li>
          <li>✅ Ideal para negocios nuevos o en crecimiento</li>
          <li>✅ Pagos flexibles y sin intereses</li>
          <li>✅ Modernización con tecnología de última generación</li>
        </ul>

        <div className="mt-10 flex flex-wrap gap-5">
          <button
            onClick={() => setIsOpen(true)}
            className="px-7 py-3.5 rounded-full bg-blue-600 text-white font-semibold text-lg shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300"
          >
            Solicitar financiamiento
          </button>

          <button
            onClick={() => setIsOpen(true)}
            className="px-7 py-3.5 rounded-full bg-gray-100 text-gray-900 font-semibold text-lg border shadow-sm hover:bg-gray-200 focus:outline-none focus:ring-4 focus:ring-gray-300"
          >
            Prueba el demo
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
    </main>
    </>
  );
}
